import { Component, ChangeDetectionStrategy, input, output } from "@angular/core";
import { PriceList } from "./price-list";
import { Product } from "./product";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { CurrencyPipe, DatePipe } from "@angular/common";
import { MatIcon } from "@angular/material/icon";
import { MatButton } from "@angular/material/button";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-product-prices",
  templateUrl: "./product-prices.component.html",
  styleUrls: ["./product-prices.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, MatButton, MatIcon, MatProgressSpinner, CurrencyPipe, DatePipe]
})
export class ProductPricesComponent {
  readonly product = input.required<Product>();
  readonly user = input.required<string>();
  readonly closeWindow = output<void>();
  selectedPrice!: PriceList;
  selectedPriceRow = -1;
  isNew!: boolean;
  isBusy!: boolean;
  errorText!: string;

  close(): void {
    this.closeWindow.emit();
  }

  productHasPrices(): boolean {
    return this.product() && this.product().priceLists && this.product().priceLists.length > 0;
  }

  selectRow(index: number, price: PriceList): void {
    this.selectedPriceRow = index;
    this.selectedPrice = price;
    this.isNew = false;
    this.errorText = null!;
  }

}
